import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import LOGO_RED_SVG from "assets/images/logo.svg";
import useLogin from "features/auth/hooks/useLogin";
import Modal from "shared/components/Modal";

function Login(){
    const {onLoginClick, inputs, onChange, isOpenModal, onModalConfirmClickHandler} = useLogin();

    return(
        <Container>
            <Modal isOpen={isOpenModal} title={"ERROR"} content={"아이디 또는 비밀번호가 틀렸습니다"} onClose={onModalConfirmClickHandler}/>
            <LoginBox>
                <LogoWrapper>
                    <img src={LOGO_RED_SVG} alt="logo" />
                </LogoWrapper>
                <Inputs>
                    <InputGroup>
                        <InputLabel>아이디</InputLabel>
                        <TextInput 
                            placeholder="아이디를 입력해주세요" 
                            onChange={onChange} 
                            name="id" 
                            value={inputs.id}
                        />
                    </InputGroup>
                    <InputGroup>
                        <InputLabel>비밀번호</InputLabel>
                        <TextInput 
                            type="password" 
                            placeholder="비밀번호를 입력해주세요" 
                            onChange={onChange} 
                            name="pw" 
                            value={inputs.pw}
                        />
                    </InputGroup>
                    <Button onClick={onLoginClick}>
                        <ButtonText>로그인</ButtonText>
                    </Button>
                </Inputs>
            </LoginBox>
        </Container>
    )
}

const Container = styled.div`
    width: 100%;
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #FFE5E5 0%, #FFE0B2 50%, #FFCDD2 100%);
    padding: 20px;
`

const LoginBox = styled.div`
    width: 100%;
    max-width: 400px;
    background: rgba(255, 255, 255, 0.95);
    border-radius: 24px;
    padding: 40px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    gap: 32px;
`

const LogoWrapper = styled.div`
    display: flex;
    justify-content: center;
    margin-bottom: 8px;

    img {
        width: 180px;
        height: auto;
    }
`

const Inputs = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
`

const InputGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`

const InputLabel = styled.label`
    color: #666;
    font-size: 14px;
    font-weight: 500;
`

const TextInput = styled.input`
    width: 100%;
    padding: 16px;
    font-size: 16px;
    border: 2px solid #F0F0F0;
    border-radius: 12px;
    background: #FFF;
    transition: all 0.2s ease;

    &::placeholder {
        color: #999;
    }

    &:focus {
        outline: none;
        border-color: #FF6B6B;
        box-shadow: 0 0 0 4px rgba(255, 107, 107, 0.1);
    }
`

const Button = styled.button`
    width: 100%;
    padding: 16px;
    background: #FF6B6B;
    border: none;
    border-radius: 12px;
    cursor: pointer;
    transition: all 0.2s ease;
    margin-top: 8px;

    &:hover {
        background: #FF5252;
        transform: translateY(-1px);
    }

    &:active {
        transform: translateY(0);
    }
`

const ButtonText = styled.span`
    color: white;
    font-size: 18px;
    font-weight: 600;
`

const RegisterLink = styled(Link)`
    text-align: center;
    text-decoration: none;
    margin-top: 8px;
`

const RegisterText = styled.span`
    color: #666;
    font-size: 14px;
    transition: all 0.2s ease;

    &:hover {
        color: #FF6B6B;
    }
`

export default Login;